import { useStore as useAuthStore } from "auth/store";

export const useFeatureFlags = () => {
  const {
    state: { user, status },
  } = useAuthStore();

  function hasPermission(featureFlag: string) {
    return user?.featureFlags?.includes(featureFlag);
  }

  const canViewCleaningDetails = hasPermission(
    "dispatch_enable_cleaning_details",
  );

  return {
    canViewCleaningDetails,
    loading: status === "initial",
  };
};
